<template>
    <div class="text-center">
        <v-bottom-sheet
            v-model="sheetShown"
            persistent
            scrollable
            :fullscreen="$vuetify.breakpoint.mobile"
            :inset="!$isSmallDesktop()"
            class="flex flex-direction: column;"
            :class="{smallDisplay: $isSmallDesktop()}"
            content-class="slotmanagement_bottomSheet">
            <v-card>
                <!-- >>> Selected Flight List -->
                <sdr-selected-flight-list
                    :filtered_selectedFlights="selectedFlights"
                    :preSelectedFlights="preSelectedFlights"
                    v-bind="{ onAssign_Update: onAssign_Update }"
                    :editorMode="editorMode"
                    :smallScreen="$isSmallDesktop()"
                    :openId="openId"
                    :selectedLayer="selectedLayer" />
                <!-- <<< Selected Flight List -->

                <!-- >>> Stepper (Dynamic) -->
                <v-card-text class="mt-3" style="height:800px;width:100%;">
                    <v-form ref="form" v-model="valid" lazy-validation>
                        <v-container style="padding:10px 30px !important;max-width: 100%">
                            <v-stepper v-model="formStepper" style="overflow:visible;position:relative;" non-linear>
                                <sdr-stepper-header
                                        :editorMode="editorMode"
                                        :validations="validation"
                                        :validationSelectedFlights="validationSelectedFlights"
                                        @change="onChange_StepperHeader" />

                                    <!-- >>> Stepper: 1 - 'Flight Config'        -->
                                    <v-stepper-content ref="stepperContent1" class="pt-3" step="1">
                                        <!-- >>> Single View -->
                                        <v-row v-if="flightLegMode === 'single'" class="input-row">
                                            <v-col class="pt-0" cols="12" sm="12">
                                                <sdr-step1-flightconfig
                                                    :editorMode="editorMode"
                                                    :editorFlightLegMode="flightLegMode"
                                                    :data="crudData"
                                                    :showDeleteCheckbox="editMultipleFlights"
                                                    leg="firstLeg"
                                                    :rules="rules"
                                                    :onFocus_setFocusedInput="onFocus_setFocusedInput"
                                                    @markToDelete="onMarkToDelete_setDeleteInformations" />
                                            </v-col>
                                        </v-row>
                                        <!-- <<< Single View -->
                                        <!-- >>> Rotation View -->
                                        <v-row v-if="flightLegMode === 'rotation'" class="input-row">
                                            <v-col cols="12" sm="5">
                                                <sdr-step1-flightconfig
                                                    :editorMode="editorMode"
                                                    :editorFlightLegMode="flightLegMode"
                                                    :showDeleteCheckbox="editMultipleFlights"
                                                    :data="crudData"
                                                    leg="firstLeg"
                                                    :rules="rules"
                                                    :onFocus_setFocusedInput="onFocus_setFocusedInput" />
                                            </v-col>

                                            <v-col class="py-0" style="display:flex;justify-content:center;" cols="12" sm="2">
                                                <div style="height:100%;width:1px;background:#ccc;" />
                                            </v-col>

                                            <v-col cols="12" sm="5">
                                                <sdr-step1-flightconfig
                                                    :editorMode="editorMode"
                                                    :editorFlightLegMode="flightLegMode"
                                                    :showDeleteCheckbox="editMultipleFlights"
                                                    :data="crudData"
                                                    leg="secondLeg"
                                                    :rules="rules"
                                                    :onFocus_setFocusedInput="onFocus_setFocusedInput" />
                                            </v-col>
                                        </v-row>
                                        <!-- <<< Rotation View -->
                                    </v-stepper-content>
                                    <!-- <<< Stepper: 1 - 'Flight Config'        -->

                                    <v-stepper-content ref="stepperContent2" class="pt-3" step="2">
                                        <!-- >>> Single / Rotation View -->
                                        <v-row class="input-row">
                                            <v-col class="pt-0" cols="12" sm="12">
                                                <sdr-step2-dateconfig
                                                    :editorMode="editorMode"
                                                    :editorFlightLegMode="flightLegMode"
                                                    :showDeleteCheckbox="editMultipleFlights"
                                                    :data="crudData"
                                                    leg="firstLeg"
                                                    :rules="rules"
                                                    :onChange_TabChange="onChange_TabChange" />
                                            </v-col>
                                        </v-row>
                                        <!-- >>> Single / Rotation View -->
                                    </v-stepper-content>

                                    <!-- >>> Stepper: 3 - 'Route Configuration'  -->
                                    <v-stepper-content ref="stepperContent3" class="pt-3" step="3">
                                        <!-- >>> Single View -->
                                        <v-row v-if="flightLegMode === 'single'" class="input-row">
                                            <v-col class="pt-0" cols="12" sm="12">
                                                <sdr-step3-routeconfig
                                                    :editorMode="editorMode"
                                                    :editorFlightLegMode="flightLegMode"
                                                    :data="crudData"
                                                    leg="firstLeg"
                                                    :rules="rules"
                                                    :showDeleteCheckbox="editMultipleFlights"
                                                    :onChange_TabChange="onChange_TabChange"
                                                    @markToDelete="onMarkToDelete_setDeleteInformations" />
                                            </v-col>
                                        </v-row>
                                        <!-- <<< Single View -->
                                        <!-- >>> Rotation View -->
                                        <v-row v-if="flightLegMode === 'rotation'" style="justify-content:space-between;" class="input-row">
                                            <v-col style="flex-grow:35">
                                                <sdr-step3-routeconfig
                                                    :editorMode="editorMode"
                                                    :editorFlightLegMode="flightLegMode"
                                                    :data="crudData"
                                                    leg="firstLeg"
                                                    :rules="rules"
                                                    :showDeleteCheckbox="editMultipleFlights"
                                                    :onChange_TabChange="onChange_TabChange" />
                                            </v-col>

                                            <v-col class="py-0" style="display:flex;justify-content:center;flex-grow:1">
                                                <div style="height:100%;width:1px;background:#ccc;" />
                                            </v-col>

                                            <v-col style="flex-grow:35">
                                                <sdr-step3-routeconfig
                                                    :editorMode="editorMode"
                                                    :editorFlightLegMode="flightLegMode"
                                                    :data="crudData"
                                                    leg="secondLeg"
                                                    :rules="rules"
                                                    :showDeleteCheckbox="editMultipleFlights"
                                                    :onChange_TabChange="onChange_TabChange" />
                                            </v-col>
                                        </v-row>
                                        <!-- <<< Rotation View -->
                                    </v-stepper-content>
                                    <!-- <<< Stepper: 3 - 'Route Configuration'  -->
                                </v-stepper>
                        </v-container>
                    </v-form>
                </v-card-text>
                <!-- <<< Stepper (Dynamic) -->

                <sdr-stepper-action-bar
                    editorMode="update"
                    :counter="filtered_selectedFlights.length"
                    :editorFlightLegMode="flightLegMode"
                    :crud-data="crudData"
                    @close="onClick_CloseSheet"
                    @save="onValidate_Form" />
            </v-card>
        </v-bottom-sheet>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { mapGetters } from 'vuex';
    import { eventBus } from '../../../../../../../main';
    import dayjs from 'dayjs';

    import BottomSheet from './BottomSheet.vue';
    import SelectedFlightList from './SelectedFlightList.vue';


    export default {
        name: 'BottomSheetUpdate',


        /* >>> *************************************************************** / /* Components */
		components: {

            'sdr-selected-flight-list': SelectedFlightList

		},
        extends: BottomSheet, // eo components{}
		/* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Props */
        props: {

            selectedFlights: Array,
            selectedLayer: Number,  // 1 Chain, 2 Rotation, 3 Leg
            editorMode: String

        }, // eo props{}
        /* <<< ****************************************************************/


        /* >>> *************************************************************** / /* Data */
        data: function() {

            return {
                // >>> -----
                deleteInformations: {
                    firstLeg: [],
                    secondLeg: []
                },
                // >>> -----
                validationSelectedFlights: {},
                // >>> -----
                filtered_selectedFlights: [],
                preSelectedFlights: [],
                emitted_selectedFlights: [],
                flightLegMode: '',
                flightTypeTab: {
                    firstLeg: 0,
                    secondLeg: 0
                },
                openId: []
            };

        }, // eo data{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** / /* Computed */
        computed: {

            ...mapGetters([
                'get_flights_Events',
                'get_similarFlights',
                'get_Airports',
                'get_flights_OCCMode',
                'get_FlightTable_Rotations_Chain_Filtered'
            ]),


            /*******************************************************************
            * editMultipleFlights
            *
            * Desc: Flag: true if user wants to update more than 1 flight.
            * Note:
            *
            */
            editMultipleFlights: {

                get() {

                    const me = this;


                    me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> computed/editMultipleFlights/get');
                    return me.emitted_selectedFlights.length > 1;

                } // eo funciton get()

            } // eo function editMultipleFlights()

        }, // eo computed{}
        /* <<< ****************************************************************/



        /********************************************************************** / /* Watch */
    watch: {}, // eo watch{}
        /* <<< ****************************************************************/



        /* >>> *************************************************************** /  /* LifeCycles */
        /***********************************************************************
        * Lifecyclehook::created
        *
        * Desc:
        * Note:
        *
        */
		created: function() {

            const me = this;


            me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> created');
            eventBus.$on('flightswasupdated', me.onEmit_FlightWasUpdated);
            eventBus.$on('markToDeleteBus', me.onMarkToDelete_setDeleteInformations);
            eventBus.$on('rotationsselected', me.onEmit_rotationsSelected);
            me.onCreate_initialUpdateConfig();

		}, // eo function created()
		/* <<< ****************************************************************/


        /***********************************************************************
        * Lifecyclehook::destroyed
        *
        * Desc:
        * Note:
        *
        */
		destroyed: function() {

            const me = this;


            me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> destroyed');
            eventBus.$off('flightswasupdated', this.onEmit_FlightWasUpdated);
            eventBus.$off('markToDeleteBus', this.onMarkToDelete_setDeleteInformations);
            eventBus.$off('rotationsselected', me.onEmit_rotationsSelected);

		}, // eo function destroyed()
        /* <<< *************************************************************** /



        /* >>> ***************************************************************** / /* Methods */
        methods: {

            //-----------------------------------------------------------------/
            // #
            // #    /$$$$$$                                                   /$$
            // #   /$$__  $$                                                 | $$
            // #  | $$  \__/  /$$$$$$  /$$$$$$$   /$$$$$$   /$$$$$$  /$$$$$$ | $$
            // #  | $$ /$$$$ /$$__  $$| $$__  $$ /$$__  $$ /$$__  $$|____  $$| $$
            // #  | $$|_  $$| $$$$$$$$| $$  \ $$| $$$$$$$$| $$  \__/ /$$$$$$$| $$
            // #  | $$  \ $$| $$_____/| $$  | $$| $$_____/| $$      /$$__  $$| $$
            // #  |  $$$$$$/|  $$$$$$$| $$  | $$|  $$$$$$$| $$     |  $$$$$$$| $$
            // #   \______/  \_______/|__/  |__/ \_______/|__/      \_______/|__/
            // #
            //-----------------------------------------------------------------/
            /*******************************************************************
            * onCreate_initialUpdateConfig()
            *
            * Desc:
            * Note:
            *
            */
            onCreate_initialUpdateConfig: function () {

                const me = this;


                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> onCreate_initialUpdateConfig');
                if (me.selectedLayer === 1) {

                    me.filtered_selectedFlights = me.selectedFlights.map(chain => {
                        if (chain.children) {
                            chain.children = chain.children.filter(rotation => rotation.type !== 'missingFlight');
                        }
                        return chain;
                    });
                    me.preSelectedFlights = me.filtered_selectedFlights[0].children;
                    me.openId = [me.filtered_selectedFlights[0].id];

                } else if (me.selectedLayer === 2) {
                    me.filtered_selectedFlights = me.selectedFlights.filter(rotation => rotation.type !== 'missingFlight');
                    me.preSelectedFlights = me.filtered_selectedFlights;

                } else if (me.selectedLayer === 3) {
                    me.preSelectedFlights = me.filtered_selectedFlights;

                }
            }, // eo function onCreate_initialUpdateConfig()


            /*******************************************************************
            * onEmit_FlightWasUpdated()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_FlightWasUpdated: function() {

                const me = this;


                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> onEmit_FlightWasUpdated');
                // >>> ----- reset
                me.deleteInformations = {
                    firstLeg: [],
                    secondLeg: []
                };

            }, // eo function onEmit_FlightWasUpdated()


            /*******************************************************************
            * onMarkToDelete_setDeleteInformations()
            *
            * Desc: Resets the rules state on tab change. (Step2RouteConfig + Step3RouteConfig)
            * Note:
            *
            */
            onMarkToDelete_setDeleteInformations: function(v) {

                const me = this;


                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> onMarkToDelete_setDeleteInformations');
                if (v.value === true) {
                    me.deleteInformations[v.leg].push(v.type);
                } else {
                    me.deleteInformations[v.leg] = me.deleteInformations[v.leg].filter(d => d !== v.type);
                }

            }, // eo function onMarkToDelete_setDeleteInformations()


            /*******************************************************************
            * setServiceFlags()
            *
            * Desc: Sets a ServiceFlag if there is one
            * Note:
            *
            */
            setServiceFlags: function(eventRecord) {

                const me = this;
                const reservations = [];


                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> setServiceFlags');
                eventRecord.baggageServiceReservation && reservations.push('BAGGAGE');
                eventRecord.flightReservation && reservations.push('FLIGHT');
                eventRecord.insuranceReservation && reservations.push('INSURANCE');
                eventRecord.mealServiceReservation && reservations.push('MEAL');
                eventRecord.medicalServiceReservation && reservations.push('MEDICAL');
                eventRecord.seatReservation && reservations.push('SEAT');
                eventRecord.standardServiceReservation && reservations.push('STANDARD');
                eventRecord.trainReservation && reservations.push('TRAIN');


                return reservations.length > 0 ? reservations : [];

            }, // eo function setServiceFlags()

            /*******************************************************************
            * onEmit_rotationsSelected()
            *
            * Desc:
            * Note:
            *
            */
            onEmit_rotationsSelected: function (flights) {

                const me = this;

                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> onEmit_rotationsSelected');
                if (flights.length > 0) {
                    me.emitted_selectedFlights = flights;
                    me.flightLegMode = flights[0].isRotation ? 'rotation' : 'single';
                    me.flightTypeTab = me.helper_getFlightTypeTab(flights[0]);
                    me.selectedFlightsValidation(flights);
                    me.onAssign_Update(me.buildFlightObjectFromCombinedFlights(flights));
                } else {
                    me.onAssign_Reset();
                }

            }, // eo function onEmit_rotationsSelected()

            /*******************************************************************
            * helper_getFlightTypeTab()
            *
            * Desc:
            * Note:
            *
            */
            helper_getFlightTypeTab: function (rotation) {

                const me = this,
                    flightTypeTab = {
                    firstLeg: 0,
                    secondLeg: 0
                };

                if (rotation.type === 'via' || rotation.type === 'via-direct') {
                    flightTypeTab.firstLeg = 1;
                } else if (rotation.type === 'via-via') {
                    flightTypeTab.firstLeg = 1;
                    flightTypeTab.secondLeg = 1;
                } else if (rotation.type === 'direct-via') {
                    flightTypeTab.secondLeg = 1;
                } else if (rotation.type === 'tria') {
                    flightTypeTab.firstLeg = 2;
                }

                return flightTypeTab;
            }, // eo function helper_getFlightTypeTab()


            //-----------------------------------------------------------------/
            // #
            // #  /$$   /$$                 /$$             /$$
            // # | $$  | $$                | $$            | $$
            // # | $$  | $$  /$$$$$$   /$$$$$$$  /$$$$$$  /$$$$$$    /$$$$$$
            // # | $$  | $$ /$$__  $$ /$$__  $$ |____  $$|_  $$_/   /$$__  $$
            // # | $$  | $$| $$  \ $$| $$  | $$  /$$$$$$$  | $$    | $$$$$$$$
            // # | $$  | $$| $$  | $$| $$  | $$ /$$__  $$  | $$ /$$| $$_____/
            // # |  $$$$$$/| $$$$$$$/|  $$$$$$$|  $$$$$$$  |  $$$$/|  $$$$$$$
            // #  \______/ | $$____/  \_______/ \_______/   \___/   \_______/
            // #           | $$
            // #           | $$
            // #           |__/
            // #
            //-----------------------------------------------------------------/
            /*******************************************************************
            * createUpdateFlightsPayload
            *
            * Desc:
            * Note:
            *
            */
            createUpdateFlightsPayload: function() {

                const me = this,
                    flightsToUpdate = me.emitted_selectedFlights,
                    payload = [];
                let legs;


                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> createUpdateFlightsPayload');
                // TODO: put into config.js (needs to stay globally updated)
                const flightObjectFields = [
                    // 1 Flight Config
                    {
                        inputName: 'input_AircraftConfig',
                        backendEmptyState: null,
                        legInfoName: 'idAircraftConfig',
                        deleteInformationsName: 'AIRCRAFTCONFIGURATION'
                    },
                    {   // future feature
                        inputName: 'input_MainServiceType',
                        backendEmptyState: 'C',
                        legInfoName: 'mainServiceType',
                        deleteInformationsName: 'mainServiceType'
                    },
                    {
                        inputName: 'input_CodeShare',
                        backendEmptyState: null,
                        legInfoName: 'codeshare',
                        deleteInformationsName: 'CODE_SHARE'
                    },
                    {
                        inputName: 'input_Range',
                        backendEmptyState: 'SHORT',
                        legInfoName: 'routeLength',
                        deleteInformationsName: 'RANGE'
                    },
                    {
                        inputName: 'input_PermissionNumber',
                        backendEmptyState: '',
                        legInfoName: 'permissionNumber',
                        deleteInformationsName: 'PERMISSION_NUMBER'
                    },
                    {
                        inputName: 'input_ServiceFlags',
                        backendEmptyState: [],
                        legInfoName: 'serviceFlags',
                        deleteInformationsName: 'SERVICE_FLAGS'
                    },
                    {
                        inputName: 'input_FlightComment',
                        backendEmptyState: null,
                        legInfoName: 'flightComment',
                        deleteInformationsName: 'FLIGHTCOMMENT'
                    },
                    {
                        inputName: 'input_Comment',
                        backendEmptyState: null,
                        legInfoName: 'comment',
                        deleteInformationsName: 'COMMENT'
                    },
                    {   // gets detected automatically in backend. no "real" input
                        inputName: 'input_flightModus',
                        backendEmptyState: null,
                        legInfoName: 'flightModus',
                        deleteInformationsName: 'FLIGHTMODUS'
                    },
                    // 2 Date
                    {
                        inputName: 'input_dates_dates',
                        backendEmptyState: null,
                        legInfoName: 'dates',
                        deleteInformationsName: 'DATE'
                    },
                    // 2 Route Config
                    // DIRECT --------------------------------------------------
                    {
                        inputName: 'input_directFlight_FlightNo',
                        type: 'D',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'flightNo',
                        deleteInformationsName: 'FLIGHTNO'
                    },
                    {
                        inputName: 'input_directFlight_AtcCallSign',
                        type: 'D',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'atcCallSign',
                        deleteInformationsName: 'ATC_CALL_SIGN'
                    },
                    {
                        inputName: 'input_directFlight_AirportDeparture',
                        type: 'D',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'aptFrom',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_directFlight_AirportDestination',
                        type: 'D',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'aptTo',
                        deleteInformationsName: 'AB_AIRPORTDESTINATION'
                    },
                    // VIA -----------------------------------------------------
                    {
                        inputName: 'input_viaFlight_FlightNo',
                        type: 'V',
                        backendEmptyState: null,
                        legInfoName: 'flightNo',
                        deleteInformationsName: 'FLIGHTNO'
                    },
                    {
                        inputName: 'input_viaFlight_AtcCallSign',
                        type: 'V',
                        backendEmptyState: null,
                        legInfoName: 'atcCallSign',
                        deleteInformationsName: 'ATC_CALL_SIGN'
                    },
                    {
                        inputName: 'input_viaFlight_AirportDeparture',
                        type: 'V',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'aptFrom',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_viaFlight_AirportVia',
                        type: 'V',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'aptTo',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_viaFlight_AirportVia',
                        type: 'V',
                        name: 'BC',
                        backendEmptyState: null,
                        legInfoName: 'aptFrom',
                        deleteInformationsName: 'AB_AIRPORTDESTINATION'
                    },
                    {
                        inputName: 'input_viaFlight_AirportDestination',
                        type: 'V',
                        name: 'BC',
                        backendEmptyState: null,
                        legInfoName: 'aptTo',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    // TRIA ----------------------------------------------------
                    {
                        inputName: 'input_triaFlight_FlightNo',
                        type: 'T',
                        backendEmptyState: null,
                        legInfoName: 'flightNo',
                        deleteInformationsName: 'FLIGHTNO'
                    },
                    {
                        inputName: 'input_triaFlight_AtcCallSign',
                        type: 'T',
                        backendEmptyState: null,
                        legInfoName: 'atcCallSign',
                        deleteInformationsName: 'ATC_CALL_SIGN'
                    },
                    {
                        inputName: 'input_triaFlight_FlightNoVia',
                        type: 'T',
                        name: 'CA',
                        backendEmptyState: null,
                        legInfoName: 'flightNo',
                        deleteInformationsName: 'FLIGHTNOVIA'
                    },
                    {
                        inputName: 'input_triaFlight_AtcCallSignVia',
                        type: 'T',
                        name: 'CA',
                        backendEmptyState: null,
                        legInfoName: 'atcCallSign',
                        deleteInformationsName: 'ATC_CALL_SIGNVIA'
                    },
                    {
                        inputName: 'input_triaFlight_AirportDestinationDeparture',
                        type: 'T',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'aptFrom',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_triaFlight_AirportFirstVia',
                        type: 'T',
                        name: 'AB',
                        backendEmptyState: null,
                        legInfoName: 'aptTo',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_triaFlight_AirportFirstVia',
                        type: 'T',
                        name: 'BC',
                        backendEmptyState: null,
                        legInfoName: 'aptFrom',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_triaFlight_AirportSecondVia',
                        type: 'T',
                        name: 'BC',
                        backendEmptyState: null,
                        legInfoName: 'aptTo',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_triaFlight_AirportSecondVia',
                        type: 'T',
                        name: 'CA',
                        backendEmptyState: null,
                        legInfoName: 'aptFrom',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    {
                        inputName: 'input_triaFlight_AirportDestinationDeparture',
                        type: 'T',
                        name: 'CA',
                        backendEmptyState: null,
                        legInfoName: 'aptTo',
                        deleteInformationsName: 'AB_AIRPORTDEPARTURE'
                    },
                    // DIRECT/VIA/TRIA -----------------------------------------
                    {
                        inputName: 'input_AB_Time_Departure_Scheduled',
                        name: 'AB',
                        backendEmptyState: null,
                        format: 'time',
                        legInfoName: 'dep_sch_time',
                        deleteInformationsName: 'AB_SCHEDULED_DEPARTURE'
                    },
                    {
                        inputName: 'input_AB_Time_Arrival_Scheduled',
                        name: 'AB',
                        backendEmptyState: null,
                        format: 'time',
                        legInfoName: 'arr_sch_time',
                        deleteInformationsName: 'AB_SCHEDULED_ARRIVAL'
                    },
                    {
                        inputName: 'input_AB_Slot_Departure',
                        name: 'AB',
                        backendEmptyState: null,
                        format: 'time',
                        legInfoName: 'dep_slt_time',
                        deleteInformationsName: 'AB_SLOT_DEPARTURE'
                    },
                    {
                        inputName: 'input_AB_Slot_Arrival',
                        name: 'AB',
                        backendEmptyState: null,
                        format: 'time',
                        legInfoName: 'arr_slt_time',
                        deleteInformationsName: 'AB_SLOT_ARRIVAL'
                    },
                    {
                        inputName: 'input_AB_Departure_SlotStatus',
                        name: 'AB',
                        backendEmptyState: '',
                        legInfoName: 'depSlotStatus',
                        deleteInformationsName: 'AB_DEPARTURE_SLOTSTATUS'
                    },
                    {
                        inputName: 'input_AB_Arrival_SlotStatus',
                        name: 'AB',
                        backendEmptyState: '',
                        legInfoName: 'arrSlotStatus',
                        deleteInformationsName: 'AB_ARRIVAL_SLOTSTATUS'
                    },
                    // VIA/TRIA ------------------------------------------------
                    {
                        inputName: 'input_BC_Time_Departure_Scheduled',
                        name: 'BC',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'dep_sch_time',
                        deleteInformationsName: 'BC_SCHEDULED_DEPARTURE'
                    },
                    {
                        inputName: 'input_BC_Time_Arrival_Scheduled',
                        name: 'BC',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'arr_sch_time',
                        deleteInformationsName: 'BC_SCHEDULED_ARRIVAL'
                    },
                    {
                        inputName: 'input_BC_Slot_Departure',
                        name: 'BC',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'dep_slt_time',
                        deleteInformationsName: 'BC_SLOT_DEPARTURE'
                    },
                    {
                        inputName: 'input_BC_Slot_Arrival',
                        name: 'BC',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'arr_slt_time',
                        deleteInformationsName: 'BC_SLOT_ARRIVAL'
                    },
                    {
                        inputName: 'input_BC_Departure_SlotStatus',
                        name: 'BC',
                        backendEmptyState: '',
                        legInfoName: 'depSlotStatus',
                        deleteInformationsName: 'BC_DEPARTURE_SLOTSTATUS'
                    },
                    {
                        inputName: 'input_BC_Arrival_SlotStatus',
                        name: 'BC',
                        backendEmptyState: '',
                        legInfoName: 'arrSlotStatus',
                        deleteInformationsName: 'BC_ARRIVAL_SLOTSTATUS'
                    },
                    // TRIA ----------------------------------------------------
                    {
                        inputName: 'input_CA_Time_Departure_Scheduled',
                        name: 'CA',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'dep_sch_time',
                        deleteInformationsName: 'CA_SCHEDULED_DEPARTURE'
                    },
                    {
                        inputName: 'input_CA_Time_Arrival_Scheduled',
                        name: 'CA',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'arr_sch_time',
                        deleteInformationsName: 'CA_SCHEDULED_ARRIVAL'
                    },
                    {
                        inputName: 'input_CA_Slot_Departure',
                        name: 'CA',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'dep_slt_time',
                        deleteInformationsName: 'CA_SLOT_DEPARTURE'
                    },
                    {
                        inputName: 'input_CA_Slot_Arrival',
                        name: 'CA',
                        format: 'time',
                        backendEmptyState: null,
                        legInfoName: 'arr_slt_time',
                        deleteInformationsName: 'CA_SLOT_ARRIVAL'
                    },
                    {
                        inputName: 'input_CA_Departure_SlotStatus',
                        name: 'CA',
                        backendEmptyState: '',
                        legInfoName: 'depSlotStatus',
                        deleteInformationsName: 'CA_DEPARTURE_SLOTSTATUS'
                    },
                    {
                        inputName: 'input_CA_Arrival_SlotStatus',
                        name: 'CA',
                        backendEmptyState: '',
                        legInfoName: 'arrSlotStatus',
                        deleteInformationsName: 'CA_ARRIVAL_SLOTSTATUS'
                    }
                ];

                const flightTypes = [
                    {
                        value: 'V',
                        backendValue: 'VIA'
                    },
                    {
                        value: 'D',
                        backendValue: 'DIRECT'
                    },
                    {
                        value: 'T',
                        backendValue: 'TRIA'
                    }
                ];

                flightsToUpdate.forEach(rotation => {

                    rotation.children.forEach(flight => {
                        // deep copy
                        const flightToEdit = JSON.parse(JSON.stringify(rotation));
                        flightToEdit.inputs = {};
                        flightObjectFields.forEach(field => {
                            // ignore input fields from different types / legs
                            if (field.name && flight.name !== field.name) {
                                return;
                            }
                            if (field.type && flight.leg.flightType !== field.type) {
                                return;
                            }

                            // DELETE ALL --------------------------------------
                            if (me.deleteInformations[flight.type].includes(field.deleteInformationsName)) {
                                flightToEdit.inputs[field.legInfoName] = field.backendEmptyState;
                                return;
                            }

                            // KEEP VALUES -------------------------------------
                            if (Vue.prototype.$isEmpty(me.crudData[flight.type][field.inputName]) === true) {
                                if (flightsToUpdate.length === 1) { // speacial case: only one flight to update
                                    flightToEdit.inputs[field.legInfoName] = field.backendEmptyState;
                                }
                                if (flightsToUpdate.length > 1) { // normal case: more than one flight to update
                                    if (field.inputName === 'input_ServiceFlags') {
                                        flightToEdit.inputs[field.legInfoName] = me.setServiceFlags(flight.leg);   // service flags backend conform
                                    } else if (field.inputName === 'input_dates_dates') {
                                        flightToEdit.inputs.dates = flight.leg.dep_sch_time; // since the date input field can be empty (because of different inputs), we need a default input because this field is mandatory in backend
                                    } else if (field.format === 'time') {
                                        flightToEdit.inputs[field.legInfoName] = flight.leg[field.legInfoName] ? dayjs(flight.leg[field.legInfoName]).utc().format('HH:mm') : ''; // equalize format because values come from backend (getLegsInfo)
                                    } else {
                                        flightToEdit.inputs[field.legInfoName] = flight.leg[field.legInfoName];
                                    }
                                };
                            }

                            // CHANGE ALL --------------------------------------
                            if (Vue.prototype.$isEmpty(me.crudData[flight.type][field.inputName]) === false) {
                                flightToEdit.inputs[field.legInfoName] = me.crudData[flight.type][field.inputName];

                            }
                        });

                        // >>> Add flight to payload
                        payload.push({
                            // >>> Step 0: 'Meta Data' ---------------------
                            idFlight: flight.leg.idFlight,
                            idStartSegment: flight.leg.idStartSegment,
                            idCreationChain: flight.leg.idCreationChain,
                            idCarrier: '43', // 43 = SUNDAIR
                            keepCrewCI: false,
                            keepCrewCO: false,
                            // >>> Step 1: 'Flight Config' ---------------------
                            idFlightConfiguration: flightToEdit.inputs.idAircraftConfig,
                            //flightModus: flightToEdit.inputs.flightModus, is detected from backend (last letter of flightNo)
                            flightComment: flightToEdit.inputs.flightComment,
                            permissionNumber: flightToEdit.inputs.permissionNumber,
                            mainServiceType: flightToEdit.inputs.mainServiceType,
                            allowedServicesForReservation: flightToEdit.inputs.serviceFlags,
                            codeShare: flightToEdit.inputs.codeshare,
                            routeLength: flightToEdit.inputs.routeLength,
                            // >>> Step 2: 'Date Config' -----------------------
                            flightDates: {
                                dateType: 'DATES',
                                dates: {
                                    dates: [
                                        // #185
                                        dayjs(flightToEdit.inputs.dates).format('YYYY-MM-DDT00:00:00[Z]')
                                    ]
                                },
                                overNight: me.isFlightOvernight(flightToEdit)
                            },
                            // >>> Step 3: 'Route Config' ----------------------
                            flightType: 'DIRECT',
                            originFlightType: flightTypes.find(value => value.value === flight.leg.flightType).backendValue,
                            directFlightInfo: {
                                atcCallSign: flightToEdit.inputs.atcCallSign,
                                ab_arr_slt_hour: flightToEdit.inputs.arr_slt_time ? flightToEdit.inputs.arr_slt_time.split(':')[0] : null,
                                ab_arr_slt_minute: flightToEdit.inputs.arr_slt_time ? flightToEdit.inputs.arr_slt_time.split(':')[1] : null,
                                ab_dep_slt_hour: flightToEdit.inputs.dep_slt_time ? flightToEdit.inputs.dep_slt_time.split(':')[0] : null,
                                ab_dep_slt_minute: flightToEdit.inputs.dep_slt_time ? flightToEdit.inputs.dep_slt_time.split(':')[1] : null,
                                aptFromIataCode: flightToEdit.inputs.aptFrom.aptCode,
                                aptToIataCode: flightToEdit.inputs.aptTo.aptCode,
                                flightNo: flightToEdit.inputs.flightNo,
                                depSlotStatus: flightToEdit.inputs.depSlotStatus,
                                arrSlotStatus: flightToEdit.inputs.arrSlotStatus,
                                flightScheduledTime: {
                                    departureHour: flightToEdit.inputs.dep_sch_time.split(':')[0],
                                    departureMinutes: flightToEdit.inputs.dep_sch_time.split(':')[1],
                                    arrivalHour: flightToEdit.inputs.arr_sch_time.split(':')[0],
                                    arrivalMinutes: flightToEdit.inputs.arr_sch_time.split(':')[1]
                                },
                                flightTime: {
                                    departureHour: flightToEdit.inputs.dep_sch_time.split(':')[0],
                                    departureMinutes: flightToEdit.inputs.dep_sch_time.split(':')[1],
                                    arrivalHour: flightToEdit.inputs.arr_sch_time.split(':')[0],
                                    arrivalMinutes: flightToEdit.inputs.arr_sch_time.split(':')[1]
                                }
                            }
                        });
                    });
                });

                return { flights: payload };

            }, // eo function createUpdateFlightsPayload()


            /*******************************************************************
            * isFlightOvernight
            *
            * Desc: Is given flight a overnight flight?
            * Note: If departure time is after arrival time the flight is
            * Note: overnight.
            *
            */
            isFlightOvernight: function(flight) {

                const me = this;
                let isOvernight = false;


                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> isFlightOvernight');
                const [dep_hour, dep_min] = flight.inputs.dep_sch_time.split(':');
                const [arr_hour, arr_min] = flight.inputs.arr_sch_time.split(':');


                if (String(dep_hour) + String(dep_min) >= String(arr_hour) + String(arr_min)) {
                    isOvernight = true;
                }
                if (String(dep_hour) + String(dep_min) === '0000' && String(arr_hour) + String(arr_min) === '0000') {
                    isOvernight = true;
                }

                return isOvernight;

            }, // eo function isFlightOvernight()


            /*******************************************************************
            * buildFlightObjectFromCombinedFlights()
            *
            * Desc:
            *
            */
            buildFlightObjectFromCombinedFlights: function(flights) {

                const me = this,
                    // >>> Step 1: 'Flight Config' -----------------------------
                    aircraftConfigs = { firstLeg: [], secondLeg: [] },
                    flightModi = { firstLeg: [], secondLeg: [] },
                    codeShares = { firstLeg: [], secondLeg: [] },
                    ranges = { firstLeg: [], secondLeg: [] },
                    flightComments = { firstLeg: [], secondLeg: [] },
                    comments = { firstLeg: [], secondLeg: [] }, // old
                    permissionNumbers = { firstLeg: [], secondLeg: [] },
                    mainServiceTypes = { firstLeg: [], secondLeg: [] },
                    // >>> Step 2: 'Date Config' -------------------------------
                    dates = { firstLeg: [], secondLeg: [] },
                    // >>> Step 3: 'Route Config' ------------------------------
                    flightNumbers = { firstLeg: [], secondLeg: [] },
                    atcCallSigns = { firstLeg: [], secondLeg: [] },
                    airportsDeparture = { firstLeg: [], secondLeg: [] },
                    airportsDestination = { firstLeg: [], secondLeg: [] },
                    AB_timesDepartureActual = { firstLeg: [], secondLeg: [] },
                    AB_timesArrivalActual = { firstLeg: [], secondLeg: [] },
                    AB_timesDepatureScheduled = { firstLeg: [], secondLeg: [] },
                    AB_timesArrivalScheduled = { firstLeg: [], secondLeg: [] },
                    AB_timesSlotDeparture = { firstLeg: [], secondLeg: [] },
                    AB_timesSlotArrival = { firstLeg: [], secondLeg: [] },
                    AB_departureSlotStatus = { firstLeg: [], secondLeg: [] },
                    AB_arrivalSlotStatus = { firstLeg: [], secondLeg: [] },
                    baggageServiceReservations = { firstLeg: [], secondLeg: [] },
                    flightReservations = { firstLeg: [], secondLeg: [] },
                    insuranceReservations = { firstLeg: [], secondLeg: [] },
                    mealServiceReservations = { firstLeg: [], secondLeg: [] },
                    medicalServiceReservations = { firstLeg: [], secondLeg: [] },
                    seatReservations = { firstLeg: [], secondLeg: [] },
                    standardServiceReservations = { firstLeg: [], secondLeg: [] },
                    trainReservations = { firstLeg: [], secondLeg: [] },
                    services = { firstLeg: [], secondLeg: [] },
                    legInfo = { firstLeg: [], secondLeg: [] },
                    // >>> Step 3: 'Route Config' VIA --------------------------
                    airportsVIA = { firstLeg: [], secondLeg: [] },
                    BC_timesDepartureActual = { firstLeg: [], secondLeg: [] },
                    BC_timesArrivalActual = { firstLeg: [], secondLeg: [] },
                    BC_timesDepatureScheduled = { firstLeg: [], secondLeg: [] },
                    BC_timesArrivalScheduled = { firstLeg: [], secondLeg: [] },
                    BC_timesSlotDeparture = { firstLeg: [], secondLeg: [] },
                    BC_timesSlotArrival = { firstLeg: [], secondLeg: [] },
                    BC_departureSlotStatus = { firstLeg: [], secondLeg: [] },
                    BC_arrivalSlotStatus = { firstLeg: [], secondLeg: [] },
                    // >>> Step 3: 'Route Config' TRIA -------------------------
                    airportsSecondVIA = { firstLeg: [], secondLeg: [] }, // tria
                    flightNoVias = { firstLeg: [], secondLeg: [] }, // tria
                    atcCallSignVias = { firstLeg: [], secondLeg: [] }, // tria
                    CA_timesDepartureActual = { firstLeg: [], secondLeg: [] },
                    CA_timesArrivalActual = { firstLeg: [], secondLeg: [] },
                    CA_timesDepatureScheduled = { firstLeg: [], secondLeg: [] },
                    CA_timesArrivalScheduled = { firstLeg: [], secondLeg: [] },
                    CA_timesSlotDeparture = { firstLeg: [], secondLeg: [] },
                    CA_timesSlotArrival = { firstLeg: [], secondLeg: [] },
                    CA_departureSlotStatus = { firstLeg: [], secondLeg: [] },
                    CA_arrivalSlotStatus = { firstLeg: [], secondLeg: [] };

                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> buildFlightObjectFromCombinedFlights');
                /*******************************************************************
                * setArrays()
                *
                * Desc: pushes every single value of the flight object into an array
                * Desc:
                *
                */
                const setArrays = (leg, index) => {
                    const tmp_services = [];

                    if (leg) {
                        // >>> Step 1: 'Flight Config' -------------------------
                        aircraftConfigs[leg.type].push(leg.leg.idAircraftConfig);
                        flightModi[leg.type].push(leg.leg.flightModus);
                        codeShares[leg.type].push(leg.leg.codeshare);
                        ranges[leg.type].push(leg.leg.routeLength);
                        baggageServiceReservations[leg.type].push(leg.leg.baggageServiceReservation);
                        flightReservations[leg.type].push(leg.leg.flightReservation);
                        insuranceReservations[leg.type].push(leg.leg.insuranceReservation);
                        mealServiceReservations[leg.type].push(leg.leg.mealServiceReservation);
                        medicalServiceReservations[leg.type].push(leg.leg.medicalServiceReservation);
                        seatReservations[leg.type].push(leg.leg.seatReservation);
                        standardServiceReservations[leg.type].push(leg.leg.standardServiceReservation);
                        trainReservations[leg.type].push(leg.leg.trainReservation);
                        flightComments[leg.type].push(leg.leg.flightComment);
                        comments[leg.type].push(leg.leg.comment); // old
                        permissionNumbers[leg.type].push(leg.leg.permissionNumber);
                        mainServiceTypes[leg.type].push(String(leg.leg.mainServiceType));
                        // >>> Step 2: 'Date Config' ---------------------------
                        dates[leg.type].push(dayjs(leg.leg.dep_sch_time).utc().format('YYYY-MM-DDT00:00:00'));
                        // >>> Step 3: 'Route Config' --------------------------
                        if (leg.name === 'AB') {
                            flightNumbers[leg.type].push(leg.leg.flightNo);
                            atcCallSigns[leg.type].push(leg.leg.atcCallSign);
                            airportsDeparture[leg.type].push(leg.leg.aptFrom.aptCode);
                            airportsDestination[leg.type].push(leg.leg.aptTo.aptCode);
                            AB_timesDepartureActual[leg.type].push(leg.leg.departureTime ? dayjs(leg.leg.departureTime).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            AB_timesArrivalActual[leg.type].push(leg.leg.arrivalTime ? dayjs(leg.leg.arrivalTime).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            AB_timesDepatureScheduled[leg.type].push(leg.leg.dep_sch_time ? dayjs(leg.leg.dep_sch_time).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            AB_timesArrivalScheduled[leg.type].push(leg.leg.arr_sch_time ? dayjs(leg.leg.arr_sch_time).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            AB_timesSlotDeparture[leg.type].push(leg.leg.dep_slt_time ? dayjs(leg.leg.dep_slt_time).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            AB_timesSlotArrival[leg.type].push(leg.leg.arr_slt_time ? dayjs(leg.leg.arr_slt_time).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            AB_departureSlotStatus[leg.type].push(leg.leg.depSlotStatus);
                            AB_arrivalSlotStatus[leg.type].push(leg.leg.arrSlotStatus);
                        } else if (leg.name === 'BC') {
                            airportsVIA[leg.type].push(leg.leg.aptFrom.aptCode);
                            airportsDestination[leg.type].pop();    // overwrite last entry pop>push
                            airportsDestination[leg.type].push(leg.leg.aptTo.aptCode);
                            BC_timesDepartureActual[leg.type].push(leg.leg.departureTime ? dayjs(leg.leg.departureTime).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            BC_timesArrivalActual[leg.type].push(leg.leg.arrivalTime ? dayjs(leg.leg.arrivalTime).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            BC_timesDepatureScheduled[leg.type].push(leg.leg.dep_sch_time ? dayjs(leg.leg.dep_sch_time).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            BC_timesArrivalScheduled[leg.type].push(leg.leg.arr_sch_time ? dayjs(leg.leg.arr_sch_time).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            BC_timesSlotDeparture[leg.type].push(leg.leg.dep_slt_time ? dayjs(leg.leg.dep_slt_time).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            BC_timesSlotArrival[leg.type].push(leg.leg.arr_slt_time ? dayjs(leg.leg.arr_slt_time).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            BC_departureSlotStatus[leg.type].push(leg.leg.depSlotStatus);
                            BC_arrivalSlotStatus[leg.type].push(leg.leg.arrSlotStatus);
                        } else if (leg.name === 'CA') {
                            airportsSecondVIA[leg.type].push(leg.leg.aptFrom.aptCode);
                            airportsDestination[leg.type].pop();    // overwrite last entry pop>push
                            airportsDestination[leg.type].push(leg.leg.aptTo.aptCode);
                            flightNoVias[leg.type].push(leg.leg.flightNo);
                            atcCallSignVias[leg.type].push(leg.leg.atcCallSign);
                            CA_timesDepartureActual[leg.type].push(leg.leg.departureTime ? dayjs(leg.leg.departureTime).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            CA_timesArrivalActual[leg.type].push(leg.leg.arrivalTime ? dayjs(leg.leg.arrivalTime).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            CA_timesDepatureScheduled[leg.type].push(leg.leg.dep_sch_time ? dayjs(leg.leg.dep_sch_time).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            CA_timesArrivalScheduled[leg.type].push(leg.leg.arr_sch_time ? dayjs(leg.leg.arr_sch_time).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            CA_timesSlotDeparture[leg.type].push(leg.leg.dep_slt_time ? dayjs(leg.leg.dep_slt_time).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            CA_timesSlotArrival[leg.type].push(leg.leg.arr_slt_time ? dayjs(leg.leg.arr_slt_time).format('2000-01-01THH:mm:00ZZ') : null); // TODO: old format "2000-01-01THH:mm:00ZZ" why?, overwrite date, it could be ignored since only the time is needed
                            CA_departureSlotStatus[leg.type].push(leg.leg.depSlotStatus);
                            CA_arrivalSlotStatus[leg.type].push(leg.leg.arrSlotStatus);
                        }

                        // special case services
                        if (leg.leg.baggageServiceReservation) {
                            tmp_services.push('BAGGAGE');
                        }
                        if (leg.leg.flightReservations) {
                            tmp_services.push('FLIGHT');
                        }
                        if (leg.leg.insuranceReservation) {
                            tmp_services.push('INSURANCE');
                        }
                        if (leg.leg.mealServiceReservation) {
                            tmp_services.push('MEAL');
                        }
                        if (leg.leg.medicalServiceReservation) {
                            tmp_services.push('MEDICAL');
                        }
                        if (leg.leg.seatReservation) {
                            tmp_services.push('SEAT');
                        }
                        if (leg.leg.standardServiceReservation) {
                            tmp_services.push('STANDARD');
                        }
                        if (leg.leg.trainReservation) {
                            tmp_services.push('TRAIN');
                        }

                        services[leg.type].push(JSON.stringify(tmp_services));
                    }
                }; // eo function setArrays()
                /*******************************************************************
                * setPayload()
                *
                * Desc: creates of every array a set of unique values
                * Desc: if the length of the array is 1, the value will be set into the input field
                * Desc: if the length of the array highter than 1, the value will be set to null or ''
                *
                */
                const setPayload = (x) => {
                    const leg = x === 0 ? 'firstLeg' : 'secondLeg';

                    // >>> Step 1: 'Flight Config' -----------------------------
                    // delete duplicates OR overwrite with the user given data from the input
                    aircraftConfigs[leg] = [...new Set(aircraftConfigs[leg])];
                    flightModi[leg] = [...new Set(flightModi[leg])];
                    codeShares[leg] = [...new Set(codeShares[leg])];
                    ranges[leg] = [...new Set(ranges[leg])];
                    // only makes sense with single flight selected (filled input_field causes update problems with missing services e.g. two flights with different services)
                    services[leg] = [...new Set(services[leg])];
                    baggageServiceReservations[leg] = baggageServiceReservations[leg].length > 0 && services[leg].length === 1 ? baggageServiceReservations[leg].reduce((a, b) => a && b) : false;
                    flightReservations[leg] = flightReservations[leg].length > 0 && services[leg].length === 1 ? flightReservations[leg].reduce((a, b) => a && b) : false;
                    insuranceReservations[leg] = insuranceReservations[leg].length > 0 && services[leg].length === 1 ? insuranceReservations[leg].reduce((a, b) => a && b) : false;
                    mealServiceReservations[leg] = mealServiceReservations[leg].length > 0 && services[leg].length === 1 ? mealServiceReservations[leg].reduce((a, b) => a && b) : false;
                    medicalServiceReservations[leg] = medicalServiceReservations[leg].length > 0 && services[leg].length === 1 ? medicalServiceReservations[leg].reduce((a, b) => a && b) : false;
                    seatReservations[leg] = seatReservations[leg].length > 0 && services[leg].length === 1 ? seatReservations[leg].reduce((a, b) => a && b) : false;
                    standardServiceReservations[leg] = standardServiceReservations[leg].length > 0 && services[leg].length === 1 ? standardServiceReservations[leg].reduce((a, b) => a && b) : false;
                    trainReservations[leg] = trainReservations[leg].length > 0 && services[leg].length === 1 ? trainReservations[leg].reduce((a, b) => a && b) : false;
                    flightComments[leg] = [...new Set(flightComments[leg])];
                    comments[leg] = [...new Set(comments[leg])]; // old
                    permissionNumbers[leg] = [...new Set(permissionNumbers[leg])];
                    mainServiceTypes[leg] = [...new Set(mainServiceTypes[leg])];
                    // >>> Step 2: 'Date Config' -------------------------------
                    dates[leg] = [...new Set(dates[leg])];
                    // >>> Step 3: 'Route Config' ------------------------------
                    flightNumbers[leg] = [...new Set(flightNumbers[leg])];
                    atcCallSigns[leg] = [...new Set(atcCallSigns[leg])];
                    airportsDeparture[leg] = [...new Set(airportsDeparture[leg])];
                    airportsDestination[leg] = [...new Set(airportsDestination[leg])];
                    AB_timesDepartureActual[leg] = [...new Set(AB_timesDepartureActual[leg])];
                    AB_timesArrivalActual[leg] = [...new Set(AB_timesArrivalActual[leg])];
                    AB_timesDepatureScheduled[leg] = [...new Set(AB_timesDepatureScheduled[leg])];
                    AB_timesArrivalScheduled[leg] = [...new Set(AB_timesArrivalScheduled[leg])];
                    AB_timesSlotDeparture[leg] = [...new Set(AB_timesSlotDeparture[leg])];
                    AB_timesSlotArrival[leg] = [...new Set(AB_timesSlotArrival[leg])];
                    AB_departureSlotStatus[leg] = [...new Set(AB_departureSlotStatus[leg])];
                    AB_arrivalSlotStatus[leg] = [...new Set(AB_arrivalSlotStatus[leg])];
                    airportsDeparture[leg] = airportsDeparture[leg].map(airport => airport);
                    airportsDestination[leg] = airportsDestination[leg].map(airport => airport);
                    // >>> Step 3: 'Route Config' VIA --------------------------
                    airportsVIA[leg] = [...new Set(airportsVIA[leg].map(airport => airport))]; // VIA
                    BC_timesDepartureActual[leg] = [...new Set(BC_timesDepartureActual[leg])]; // VIA
                    BC_timesArrivalActual[leg] = [...new Set(BC_timesArrivalActual[leg])]; // VIA
                    BC_timesDepatureScheduled[leg] = [...new Set(BC_timesDepatureScheduled[leg])]; // VIA
                    BC_timesArrivalScheduled[leg] = [...new Set(BC_timesArrivalScheduled[leg])]; // VIA
                    BC_timesSlotDeparture[leg] = [...new Set(BC_timesSlotDeparture[leg])]; // VIA
                    BC_timesSlotArrival[leg] = [...new Set(BC_timesSlotArrival[leg])]; // VIA
                    BC_departureSlotStatus[leg] = [...new Set(BC_departureSlotStatus[leg])]; // VIA
                    BC_arrivalSlotStatus[leg] = [...new Set(BC_arrivalSlotStatus[leg])]; // VIA
                    // >>> Step 3: 'Route Config' TRIA -------------------------
                    airportsSecondVIA[leg] = [...new Set(airportsSecondVIA[leg].map(airport => airport))]; // TRIA
                    flightNoVias[leg] = [...new Set(flightNoVias[leg])]; // TRIA
                    atcCallSignVias[leg] = [...new Set(atcCallSignVias[leg])]; // TRIA
                    CA_timesDepartureActual[leg] = [...new Set(CA_timesDepartureActual[leg])]; // TRIA
                    CA_timesArrivalActual[leg] = [...new Set(CA_timesArrivalActual[leg])]; // TRIA
                    CA_timesDepatureScheduled[leg] = [...new Set(CA_timesDepatureScheduled[leg])]; // TRIA
                    CA_timesArrivalScheduled[leg] = [...new Set(CA_timesArrivalScheduled[leg])]; // TRIA
                    CA_timesSlotDeparture[leg] = [...new Set(CA_timesSlotDeparture[leg])]; // TRIA
                    CA_timesSlotArrival[leg] = [...new Set(CA_timesSlotArrival[leg])]; // TRIA
                    CA_departureSlotStatus[leg] = [...new Set(CA_departureSlotStatus[leg])]; // TRIA
                    CA_arrivalSlotStatus[leg] = [...new Set(CA_arrivalSlotStatus[leg])]; // TRIA


                    legInfo[leg] = {
                        // >>> Step 1: 'Flight Config' -------------------------
                        idFlight: null, // TODO:
                        idAircraftConfig: aircraftConfigs[leg].length === 1 ? aircraftConfigs[leg][0] : null,
                        flightModus: flightModi[leg].length === 1 ? flightModi[leg][0] : null,
                        codeshare: codeShares[leg].length === 1 ? codeShares[leg][0] : null,
                        routeLength: ranges[leg].length === 1 ? ranges[leg][0] : null,
                        baggageServiceReservation: baggageServiceReservations[leg],
                        flightReservation: flightReservations[leg],
                        insuranceReservation: insuranceReservations[leg],
                        mealServiceReservation: mealServiceReservations[leg],
                        medicalServiceReservation: medicalServiceReservations[leg],
                        seatReservation: seatReservations[leg],
                        standardServiceReservation: standardServiceReservations[leg],
                        trainReservation: trainReservations[leg],
                        flightComment: flightComments[leg].length === 1 ? flightComments[leg][0] : '',
                        comment: comments[leg].length === 1 ? comments[leg][0] : '', // old
                        permissionNumber: permissionNumbers[leg].length === 1 ? permissionNumbers[leg][0] : null,
                        mainServiceType: mainServiceTypes[leg].length === 1 ? mainServiceTypes[leg][0] : null,
                        // >>> Step 2: 'Date Config' ---------------------------
                        dates: dates[leg].length === 1 ? dates[leg][0] : null,
                        // >>> Step 3: 'Route Config' TRIA ---------------------
                        flightNo: flightNumbers[leg].length === 1 ? flightNumbers[leg][0] : null,
                        atcCallSign: atcCallSigns[leg].length === 1 ? atcCallSigns[leg][0] : null,
                        aptFrom: airportsDeparture[leg].length === 1 ? me.get_Airports.find((airport) => airport.iataCode === airportsDeparture[leg][0]) : null,
                        aptTo: airportsDestination[leg].length === 1 ? me.get_Airports.find((airport) => airport.iataCode === airportsDestination[leg][0]) : null,
                        departureTime: AB_timesDepartureActual[leg].length === 1 && AB_timesDepartureActual[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(AB_timesDepartureActual[leg][0]).format('HH:mm:00ZZ') : null,
                        arrivalTime: AB_timesArrivalActual[leg].length === 1 && AB_timesArrivalActual[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(AB_timesArrivalActual[leg][0]).format('HH:mm:00ZZ') : null,
                        dep_sch_time: AB_timesDepatureScheduled[leg].length === 1 && AB_timesDepatureScheduled[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(AB_timesDepatureScheduled[leg][0]).format('HH:mm:00ZZ') : null,
                        arr_sch_time: AB_timesArrivalScheduled[leg].length === 1 && AB_timesArrivalScheduled[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(AB_timesArrivalScheduled[leg][0]).format('HH:mm:00ZZ') : null,
                        dep_slt_time: AB_timesSlotDeparture[leg].length === 1 && AB_timesSlotDeparture[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(AB_timesSlotDeparture[leg][0]).format('HH:mm:00ZZ') : null,
                        arr_slt_time: AB_timesSlotArrival[leg].length === 1 && AB_timesSlotArrival[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(AB_timesSlotArrival[leg][0]).format('HH:mm:00ZZ') : null,
                        depSlotStatus: AB_departureSlotStatus[leg].length === 1 ? AB_departureSlotStatus[leg][0] : '',
                        arrSlotStatus: AB_arrivalSlotStatus[leg].length === 1 ? AB_arrivalSlotStatus[leg][0] : '',
                        // >>> Step 3: 'Route Config' VIA ----------------------
                        aptVIA: airportsVIA[leg].length === 1 ? me.get_Airports.find((airport) => airport.iataCode === airportsVIA[leg][0]) : null, // VIA
                        BC_departureTime: BC_timesDepartureActual[leg].length === 1 && BC_timesDepartureActual[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(BC_timesDepartureActual[leg][0]).format('HH:mm:00ZZ') : null, // VIA
                        BC_arrivalTime: BC_timesArrivalActual[leg].length === 1 && BC_timesArrivalActual[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(BC_timesArrivalActual[leg][0]).format('HH:mm:00ZZ') : null, // VIA
                        BC_dep_sch_time: BC_timesDepatureScheduled[leg].length === 1 && BC_timesDepatureScheduled[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(BC_timesDepatureScheduled[leg][0]).format('HH:mm:00ZZ') : null, // VIA
                        BC_arr_sch_time: BC_timesArrivalScheduled[leg].length === 1 && BC_timesArrivalScheduled[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(BC_timesArrivalScheduled[leg][0]).format('HH:mm:00ZZ') : null, // VIA
                        BC_dep_slt_time: BC_timesSlotDeparture[leg].length === 1 && BC_timesSlotDeparture[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(BC_timesSlotDeparture[leg][0]).format('HH:mm:00ZZ') : null, // VIA
                        BC_arr_slt_time: BC_timesSlotArrival[leg].length === 1 && BC_timesSlotArrival[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(BC_timesSlotArrival[leg][0]).format('HH:mm:00ZZ') : null, // VIA
                        BC_depSlotStatus: BC_departureSlotStatus[leg].length === 1 ? BC_departureSlotStatus[leg][0] : '', // VIA
                        BC_arrSlotStatus: BC_arrivalSlotStatus[leg].length === 1 ? BC_arrivalSlotStatus[leg][0] : '', // VIA
                        // >>> Step 3: 'Route Config' TRIA ---------------------
                        airportSecondVIA: airportsSecondVIA[leg].length === 1 ? me.get_Airports.find((airport) => airport.iataCode === airportsSecondVIA[leg][0]) : null, // TRIA
                        flightNoVia: flightNoVias[leg].length === 1 ? flightNoVias[leg][0] : null, // TRIA
                        atcCallSignVia: atcCallSignVias[leg].length === 1 ? atcCallSignVias[leg][0] : null, // TRIA
                        CA_departureTime: CA_timesDepartureActual[leg].length === 1 && CA_timesDepartureActual[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(CA_timesDepartureActual[leg][0]).format('HH:mm:00ZZ') : null, // TRIA
                        CA_arrivalTime: CA_timesArrivalActual[leg].length === 1 && CA_timesArrivalActual[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(CA_timesArrivalActual[leg][0]).format('HH:mm:00ZZ') : null, // TRIA
                        CA_dep_sch_time: CA_timesDepatureScheduled[leg].length === 1 && CA_timesDepatureScheduled[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(CA_timesDepatureScheduled[leg][0]).format('HH:mm:00ZZ') : null, // TRIA
                        CA_arr_sch_time: CA_timesArrivalScheduled[leg].length === 1 && CA_timesArrivalScheduled[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(CA_timesArrivalScheduled[leg][0]).format('HH:mm:00ZZ') : null, // TRIA
                        CA_dep_slt_time: CA_timesSlotDeparture[leg].length === 1 && CA_timesSlotDeparture[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(CA_timesSlotDeparture[leg][0]).format('HH:mm:00ZZ') : null, // TRIA
                        CA_arr_slt_time: CA_timesSlotArrival[leg].length === 1 && CA_timesSlotArrival[leg][0] ? dayjs().format('YYYY-MM-DDT') + dayjs(CA_timesSlotArrival[leg][0]).format('HH:mm:00ZZ') : null, // TRIA
                        CA_depSlotStatus: CA_departureSlotStatus[leg].length === 1 ? CA_departureSlotStatus[leg][0] : '', // TRIA
                        CA_arrSlotStatus: CA_arrivalSlotStatus[leg].length === 1 ? CA_arrivalSlotStatus[leg][0] : '', // TRIA

                        idStartSegment: null, // TODO:
                        flightTypeTab: me.helper_getFlightTypeTab(flights[0])
                    };
                }; // eo function setPayload()

                if (me.selectedLayer !== 3) {
                    flights.forEach(rotation => {
                        rotation.children.forEach(leg => {

                            setArrays(leg);
                        });
                    });

                    for (let x = 0; x < flights[0].children.length; x++) {

                            setPayload(x);
                    }
                }

                return legInfo;

            }, // eo function buildFlightObjectFromCombinedFlights()


            /*******************************************************************
            * selectedFlightsValidation
            *
            * Desc: Which Flights are selected? Makes the List "smart(er)"
            * Note: eg. if Validation "isOnSameDate" matches -> Flight Config can't get edited
            * Note: eg. if Validation "isOnSameDate" don't matches -> Flight Dates can't get edited
            *
            */
            selectedFlightsValidation: function(rotations) {

                const me = this,
                    validationSelectedFlights = {
                        isNoFlightSelected: false,
                        isOneDate: false,
                        isMoreDatesOrOneSelectedFlight: false,
                        maxOneParentSelected: false,
                        isMixedSelection: false,
                        step2IsEditable: false,
                        step3IsEditable: false
                    };
                let rotationDates = [];


                me.$toc('>>> views/shared/components/BottomSheetUpdate.vue >>> selectedFlightsValidation');


                rotations.forEach((rotation) => {
                    rotationDates.push(dayjs(rotation.date).format('YYYY-MM-DD'));
                });

                rotationDates = [...new Set(rotationDates)];


                validationSelectedFlights.isNoFlightSelected = rotations.length === 0;
                validationSelectedFlights.isOneDate = rotationDates.length === 1;
                validationSelectedFlights.isMoreDatesOrOneSelectedFlight = rotationDates.length > 1 || rotations.length === 1;
                validationSelectedFlights.maxOneParentSelected = rotations.length > 2 || true; // TODO:CHECK FOR PARENT NODES
                validationSelectedFlights.isMixedSelection = '';
                validationSelectedFlights.step3IsEditable = validationSelectedFlights.isNoFlightSelected || (validationSelectedFlights.isMoreDatesOrOneSelectedFlight && validationSelectedFlights.maxOneParentSelected);
                validationSelectedFlights.step2IsEditable = validationSelectedFlights.isNoFlightSelected || validationSelectedFlights.isOneDate;

                me.validationSelectedFlights = validationSelectedFlights;
                eventBus.$emit('validationSelectedFlightsChange', validationSelectedFlights);

            } // eo function selectedFlightsValidation()

        } // eo methods{}
        /* <<< ****************************************************************/
    };
</script>

<style>
    .slotmanagement_bottomSheet.v-dialog:not(.v-dialog--fullscreen) {
        max-height: 100%;
    }
</style>
